var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Version")]),_vm._v(" 2.4.18")]),_c('strong',[_vm._v("Copyright © RSUD BK.")]),_vm._v(" All rights reserved. ")])
}]

export { render, staticRenderFns }